import { render, staticRenderFns } from "./LayoutShowConfigTab.vue?vue&type=template&id=6ef63af0"
import script from "./LayoutShowConfigTab.vue?vue&type=script&lang=ts"
export * from "./LayoutShowConfigTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports